import React from 'react'
const SvgChoose3 = props => (
  <svg id='choose3_svg___\u56FE\u5C42_2' viewBox='0 0 640.57 224.69' {...props}>
    <defs>
      <style>
        {
          '.choose3_svg__cls-1{fill:none;stroke:#8796aa;stroke-dasharray:0 0 4 4;stroke-miterlimit:10}.choose3_svg__cls-3{letter-spacing:0}.choose3_svg__cls-4{letter-spacing:.03em}.choose3_svg__cls-5,.choose3_svg__cls-6{letter-spacing:.02em}.choose3_svg__cls-7{fill:#00b5b0}.choose3_svg__cls-8{fill:#fd5c1f}.choose3_svg__cls-9{fill:#252a3a}.choose3_svg__cls-10,.choose3_svg__cls-11,.choose3_svg__cls-6{fill:#8796aa}.choose3_svg__cls-11,.choose3_svg__cls-6{font-family:Roboto-Regular,Roboto;font-size:12px}.choose3_svg__cls-13,.choose3_svg__cls-14{letter-spacing:.03em}.choose3_svg__cls-18{letter-spacing:.01em}'
        }
      </style>
    </defs>
    <g id='choose3_svg___\u56FE\u5C42_1-2'>
      <path
        className='choose3_svg__cls-8'
        d='M132.58 95.03h-17.81v30h24.83v-23.56l-7.02-6.44zm-15.74 27.93V97.1h13.45v6.21h7.24v19.66h-20.69z'
      />
      <path
        className='choose3_svg__cls-8'
        d='M118.91 107.44h9.67v2.07h-9.67zM118.91 112.62h15.52v2.07h-15.52zM118.91 117.79h15.52v2.07h-15.52z'
      />
      <path className='choose3_svg__cls-1' d='M382.05 25.03h132.5v140h-336v-140h135.5' />
      <path fill='#f4f8fa' stroke='#dae0e5' strokeMiterlimit={10} d='M199.55 76.03h296v70h-296z' />
      <path className='choose3_svg__cls-10' d='M74.96 109.03h24v2h-24z' />
      <path className='choose3_svg__cls-10' d='M98.38 104.03l8 6-8 6M146.96 109.03h45v2h-45z' />
      <path className='choose3_svg__cls-10' d='M191.38 104.03l8 6-8 6M495.96 109.03h56v2h-56z' />
      <path className='choose3_svg__cls-10' d='M551.38 104.03l8 6-8 6' />
      <text className='choose3_svg__cls-6' transform='translate(0 151.35)'>
        <tspan x={0} y={0}>
          {'Sending Host'}
        </tspan>
      </text>
      <text className='choose3_svg__cls-6' transform='translate(556.52 152.35)'>
        <tspan x={0} y={0}>
          {'Receiving Host'}
        </tspan>
      </text>
      <text className='choose3_svg__cls-11' transform='translate(281.7 66.61)'>
        <tspan className='choose3_svg__cls-5' x={0} y={0}>
          {'R'}
        </tspan>
        <tspan x={7.69} y={0} letterSpacing='.02em'>
          {'a'}
        </tspan>
        <tspan className='choose3_svg__cls-4' x={14.43} y={0}>
          {'ysync'}
        </tspan>
        <tspan x={46.37} y={0} letterSpacing={0} />
        <tspan x={49.41} y={0} letterSpacing='-.01em'>
          {'T'}
        </tspan>
        <tspan className='choose3_svg__cls-3' x={56.43} y={0}>
          {'r'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={60.56} y={0}>
          {'ans'}
        </tspan>
        <tspan className='choose3_svg__cls-18' x={80.79} y={0}>
          {'f'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={85.12} y={0}>
          {'er Engine'}
        </tspan>
      </text>
      <text className='choose3_svg__cls-11' transform='translate(270.44 102.02)'>
        <tspan className='choose3_svg__cls-5'>
          <tspan x={0} y={0}>
            {'AES-256 '}
          </tspan>
        </tspan>
        <tspan className='choose3_svg__cls-5' x={0} y={14.4}>
          {'Enc'}
        </tspan>
        <tspan className='choose3_svg__cls-14' x={20.62} y={14.4}>
          {'r'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={25.09} y={14.4}>
          {'yption'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={0} y={28.8}>
          {'P'}
        </tspan>
        <tspan x={7.87} y={28.8} letterSpacing='.02em'>
          {'r'}
        </tspan>
        <tspan className='choose3_svg__cls-4' x={12.11} y={28.8}>
          {'otection'}
        </tspan>
      </text>
      <text className='choose3_svg__cls-11' transform='translate(138.44 211.02)'>
        <tspan className='choose3_svg__cls-5' x={0} y={0}>
          {'TLS enc'}
        </tspan>
        <tspan className='choose3_svg__cls-13' x={45.07} y={0}>
          {'r'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={49.53} y={0}>
          {'ypted t'}
        </tspan>
        <tspan className='choose3_svg__cls-3' x={87.98} y={0}>
          {'r'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={92.1} y={0}>
          {'ans'}
        </tspan>
        <tspan className='choose3_svg__cls-18' x={112.34} y={0}>
          {'f'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={116.67} y={0}>
          {'er'}
        </tspan>
      </text>
      <text className='choose3_svg__cls-11' transform='translate(394.44 102.02)'>
        <tspan className='choose3_svg__cls-5' x={0} y={0}>
          {'CVE vulne'}
        </tspan>
        <tspan className='choose3_svg__cls-3' x={56.25} y={0}>
          {'r'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={60.38} y={0}>
          {'ability '}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={0} y={14.4}>
          {'risk lib'}
        </tspan>
        <tspan className='choose3_svg__cls-3' x={37.17} y={14.4}>
          {'r'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={41.3} y={14.4}>
          {'a'}
        </tspan>
        <tspan className='choose3_svg__cls-14' x={48.12} y={14.4}>
          {'r'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={52.59} y={14.4}>
          {'y '}
        </tspan>
        <tspan className='choose3_svg__cls-5'>
          <tspan x={0} y={28.8}>
            {'scanning'}
          </tspan>
        </tspan>
      </text>
      <path
        className='choose3_svg__cls-8'
        d='M349.25 12.5c-2.91 0-5.81.56-8.37 1.19l1.89 1.36c-2.55.48-5.16.34-6.59.02v5.57c1.94.51 8.33.14 11.13-1.01l-.88-1.06c1.03-.1 1.73-.12 2.81-.12 2.98 0 5.81.41 8.37 1.16v-5.92c-2.42-.6-5.46-1.19-8.37-1.19z'
      />
      <path
        className='choose3_svg__cls-9'
        d='M358.13 34.11c-1.95.2-3.32.52-4.7.92v1.64c-2.16.49-5.65.97-8.46.79-2.9-.18-6.65-1.23-8.27-1.85v-5.89c2.29 1.22 6.63 2.04 10.21 2.04 1.99 0 4.44-.26 5.88-.56l-.28-1.47c1.83-.63 2.97-1.16 5.64-1.42v5.8zM354.47 20.73c-2.03 0-5 .47-5.84.7l.97 1.56c-2.19.55-4.37.54-5.97.54-3.76 0-6.95-.79-10.27-2.06v5.9c2.55.87 5.82 1.54 8.93 1.54s6.51-.42 9.42-1.43l-.27-.72c1.01-.13 1.88-.19 2.99-.19 2.09 0 3.84.07 6.02.59v-5.92c-1.2-.26-3.94-.53-5.97-.53z'
      />
      <path
        className='choose3_svg__cls-10'
        d='M9.78 92.53h53.33v34.17h2.5V93.02c0-1.65-1.34-2.99-2.99-2.99H10.27c-1.65 0-2.99 1.34-2.99 2.99v33.68h2.5V92.53zM.62 126.7c0 1.84 1.49 3.33 3.33 3.33h65c1.84 0 3.33-1.49 3.33-3.33H.62z'
      />
      <path
        className='choose3_svg__cls-7'
        d='M43.44 105.67c-.52-2.86-3.01-5.03-6.02-5.03-2.37 0-4.53 1.37-5.54 3.52-2.73-.1-5.01 2.04-5.11 4.77-.1 2.73 2.04 5.01 4.77 5.11h.89l.72-2.59-1.75-1.61 7.34-5.07-4.71 15.88 7.55-4.92-1.88-1.7h2.87l.16.01a4.224 4.224 0 004.06-4.38 4.192 4.192 0 00-3.35-3.98z'
      />
      <path
        className='choose3_svg__cls-10'
        d='M568.28 92.53h53.33v34.17h2.5V93.02c0-1.65-1.34-2.99-2.99-2.99h-52.35c-1.65 0-2.99 1.34-2.99 2.99v33.68h2.5V92.53zM559.11 126.7c0 1.84 1.49 3.33 3.33 3.33h65c1.84 0 3.33-1.49 3.33-3.33H559.1z'
      />
      <path
        className='choose3_svg__cls-7'
        d='M602.95 107.03c-.34 0-.68.03-1 .08v-.08c0-3.87-3.13-7-7-7-3.17 0-5.85 2.11-6.71 5.01h-.29c-3.87 0-7 3.13-7 7s3.13 7 7 7h6.12v-6.73l-3.62 3.73-1.5-1.6 6-6.4 6 6.4-1.5 1.6-3.62-3.73v6.73h6.12v-.08c.33.05.66.08 1 .08 3.31 0 6-2.69 6-6s-2.69-6-6-6z'
      />
      <path
        className='choose3_svg__cls-8'
        d='M256.38 98.42c-1.92-.66-5.71-1.9-7.63-2.86-3.83-1.9-5.27-3.2-6.7-4.28-.5-.38-1.2-.57-1.89-.57h-.02-.02c-.7 0-1.39.19-1.89.57-1.42 1.09-2.87 2.38-6.7 4.28-1.91.95-5.7 2.2-7.63 2.86-1.24.42-2.05 1.54-1.94 2.86.33 4.06 1.33 12.17 3.83 17.13 2.87 5.71 10.07 10.18 12.91 11.9.45.27.94.41 1.43.41s.98-.14 1.43-.41c2.85-1.71 10.04-6.19 12.91-11.9 2.49-4.96 3.49-13.07 3.83-17.13.11-1.31-.69-2.43-1.94-2.86zm-3.51 19.17c-1.81 3.61-5.93 7.36-12.23 11.16-.16.1-.33.15-.5.15s-.33-.05-.5-.15c-6.3-3.8-10.41-7.55-12.23-11.16-2.54-5.05-3.43-13.88-3.64-16.46-.05-.67.53-.92.71-.99l.69-.23c2.13-.72 5.35-1.81 7.16-2.71 3.48-1.73 5.12-3.01 6.43-4.03.19-.15.37-.29.56-.43.11-.09.36-.19.72-.2s.1 0 .1 0h.05c.37 0 .63.11.74.2.18.14.37.28.56.43 1.31 1.02 2.95 2.3 6.43 4.03 1.81.9 5.03 1.99 7.16 2.71l.69.23c.18.06.77.32.71.99-.21 2.59-1.1 11.42-3.64 16.46zm-3.78-13.5c-3.35-.65-6.5-2.38-8.02-3.71-.25-.22-.64-.26-.84-.26-.18 0-.62.03-.91.28-1.52 1.32-4.68 3.05-8.02 3.69-.48.1-.84 1.01-.78 1.49.04.34.08.72.12 1.14.23 2.32.57 5.83 2.88 8.97 1.57 2.14 4.04 4.36 6.16 5.52.13.07.31.1.55.1.27 0 .4-.05.47-.09 2.14-1.17 4.62-3.4 6.16-5.54 2.12-2.94 2.51-6.6 2.77-9.02.04-.4.08-.76.12-1.08.05-.38-.12-1.38-.68-1.49zm-2.99 11.03c-1.44 2-3.85 4.16-5.77 5.23h-.19c-2-1.1-4.35-3.21-5.84-5.24-.8-1.09-1.34-2.21-1.72-3.32l7.57 3.24 7.58-3.24c-.37 1.15-.88 2.29-1.63 3.33zm1.96-4.5l-7.91 3.38-7.92-3.39a21.38 21.38 0 01-.51-2.92l8.43 3.53 8.41-3.53c-.11.9-.26 1.89-.5 2.92zm.64-4.07v.07l-8.54 3.58-8.55-3.58c-.04-.43-.08-.82-.13-1.17-.01-.09.08-.33.15-.45 3.48-.7 6.68-2.45 8.32-3.88.03-.02.13-.05.29-.05.13 0 .21.03.21.02 1.63 1.44 4.82 3.19 8.29 3.9.05.13.1.35.08.46-.04.33-.08.7-.13 1.1zM108.87 201.06h-6.36c-.25 0-.45.2-.45.45s.2.45.45.45h6.36c.25 0 .45-.2.45-.45s-.2-.45-.45-.45zm0 4.55h-6.36c-.25 0-.45.2-.45.45s.2.45.45.45h6.36c.25 0 .45-.2.45-.45s-.2-.45-.45-.45zm6.82-8.18c-2.51 0-4.55 2.04-4.55 4.55 0 1.02.35 1.95.91 2.7v5.02a.454.454 0 00.68.39l2.96-1.69 2.96 1.69a.465.465 0 00.46 0c.14-.08.23-.23.23-.39v-5-.02c.57-.76.91-1.69.91-2.7 0-2.51-2.04-4.55-4.55-4.55zm2.73 11.49l-2.5-1.43a.452.452 0 00-.45 0l-2.5 1.43v-3.33c.76.58 1.7.93 2.73.93s1.97-.36 2.73-.93v3.33zm-2.73-3.31a3.64 3.64 0 110-7.28 3.64 3.64 0 010 7.28zm11.69-13.2c-1.92-.66-5.71-1.9-7.63-2.86-3.83-1.9-5.27-3.2-6.7-4.28-.5-.38-1.2-.57-1.89-.57h-.02-.02c-.7 0-1.39.19-1.89.57-1.42 1.09-2.87 2.38-6.7 4.28-1.91.95-5.7 2.2-7.63 2.86-1.24.42-2.05 1.54-1.94 2.86.33 4.06 1.33 12.17 3.83 17.13 2.87 5.71 10.07 10.18 12.91 11.9.45.27.94.41 1.43.41s.98-.14 1.43-.41c2.85-1.71 10.04-6.19 12.91-11.9 2.49-4.96 3.49-13.07 3.83-17.13.11-1.31-.69-2.43-1.94-2.86zm-3.51 19.17c-1.81 3.61-5.93 7.36-12.23 11.16-.16.1-.33.15-.5.15s-.33-.05-.5-.15c-6.3-3.8-10.41-7.55-12.23-11.16-2.54-5.05-3.43-13.88-3.64-16.46-.05-.67.53-.92.71-.99l.69-.23c2.13-.72 5.35-1.81 7.16-2.71 3.48-1.73 5.12-3.01 6.43-4.03.19-.15.37-.29.56-.43.11-.09.36-.19.72-.2s.1 0 .1 0h.05c.37 0 .63.11.74.2.18.14.37.28.56.43 1.31 1.02 2.95 2.3 6.43 4.03 1.81.9 5.03 1.99 7.16 2.71l.69.23c.18.06.77.32.71.99-.21 2.59-1.1 11.42-3.64 16.46zm-2.72-15.97h-20c-1 0-1.82.82-1.82 1.82v12.73c0 1 .82 1.82 1.82 1.82h20c1 0 1.82-.82 1.82-1.82v-12.73c0-1-.82-1.82-1.82-1.82zm.91 14.55c0 .5-.41.91-.91.91h-20c-.5 0-.91-.41-.91-.91v-12.73c0-.5.41-.91.91-.91h20c.5 0 .91.41.91.91v12.73zm-6.36-10.45c-1.25 0-2.27 1.02-2.27 2.27s1.02 2.27 2.27 2.27 2.27-1.02 2.27-2.27-1.02-2.27-2.27-2.27zm0 3.64c-.75 0-1.36-.61-1.36-1.36s.61-1.36 1.36-1.36 1.36.61 1.36 1.36-.61 1.36-1.36 1.36z'
      />
      <text className='choose3_svg__cls-11' transform='translate(507.44 208.02)'>
        <tspan className='choose3_svg__cls-5' x={0} y={0}>
          {'TLS enc'}
        </tspan>
        <tspan className='choose3_svg__cls-13' x={45.07} y={0}>
          {'r'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={49.53} y={0}>
          {'ypted t'}
        </tspan>
        <tspan className='choose3_svg__cls-3' x={87.98} y={0}>
          {'r'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={92.1} y={0}>
          {'ans'}
        </tspan>
        <tspan className='choose3_svg__cls-18' x={112.34} y={0}>
          {'f'}
        </tspan>
        <tspan className='choose3_svg__cls-5' x={116.67} y={0}>
          {'er'}
        </tspan>
      </text>
      <path
        className='choose3_svg__cls-8'
        d='M480.87 201.06h-6.36c-.25 0-.45.2-.45.45s.2.45.45.45h6.36c.25 0 .45-.2.45-.45s-.2-.45-.45-.45zm0 4.55h-6.36c-.25 0-.45.2-.45.45s.2.45.45.45h6.36c.25 0 .45-.2.45-.45s-.2-.45-.45-.45zm6.82-8.18c-2.51 0-4.55 2.04-4.55 4.55 0 1.02.35 1.95.91 2.7v5.02a.454.454 0 00.68.39l2.96-1.69 2.96 1.69a.465.465 0 00.46 0c.14-.08.23-.23.23-.39v-5-.02c.57-.76.91-1.69.91-2.7 0-2.51-2.04-4.55-4.55-4.55zm2.73 11.49l-2.5-1.43a.452.452 0 00-.45 0l-2.5 1.43v-3.33c.76.58 1.7.93 2.73.93s1.97-.36 2.73-.93v3.33zm-2.73-3.31a3.64 3.64 0 110-7.28 3.64 3.64 0 010 7.28zm11.69-13.2c-1.92-.66-5.71-1.9-7.63-2.86-3.83-1.9-5.27-3.2-6.7-4.28-.5-.38-1.2-.57-1.89-.57h-.02-.02c-.7 0-1.39.19-1.89.57-1.42 1.09-2.87 2.38-6.7 4.28-1.91.95-5.7 2.2-7.63 2.86-1.24.42-2.05 1.54-1.94 2.86.33 4.06 1.33 12.17 3.83 17.13 2.87 5.71 10.07 10.18 12.91 11.9.45.27.94.41 1.43.41s.98-.14 1.43-.41c2.85-1.71 10.04-6.19 12.91-11.9 2.49-4.96 3.49-13.07 3.83-17.13.11-1.31-.69-2.43-1.94-2.86zm-3.51 19.17c-1.81 3.61-5.93 7.36-12.23 11.16-.16.1-.33.15-.5.15s-.33-.05-.5-.15c-6.3-3.8-10.41-7.55-12.23-11.16-2.54-5.05-3.43-13.88-3.64-16.46-.05-.67.53-.92.71-.99l.69-.23c2.13-.72 5.35-1.81 7.16-2.71 3.48-1.73 5.12-3.01 6.43-4.03.19-.15.37-.29.56-.43.11-.09.36-.19.72-.2s.1 0 .1 0h.05c.37 0 .63.11.74.2.18.14.37.28.56.43 1.31 1.02 2.95 2.3 6.43 4.03 1.81.9 5.03 1.99 7.16 2.71l.69.23c.18.06.77.32.71.99-.21 2.59-1.1 11.42-3.64 16.46zm-2.72-15.97h-20c-1 0-1.82.82-1.82 1.82v12.73c0 1 .82 1.82 1.82 1.82h20c1 0 1.82-.82 1.82-1.82v-12.73c0-1-.82-1.82-1.82-1.82zm.91 14.55c0 .5-.41.91-.91.91h-20c-.5 0-.91-.41-.91-.91v-12.73c0-.5.41-.91.91-.91h20c.5 0 .91.41.91.91v12.73zm-6.36-10.45c-1.25 0-2.27 1.02-2.27 2.27s1.02 2.27 2.27 2.27 2.27-1.02 2.27-2.27-1.02-2.27-2.27-2.27zm0 3.64c-.75 0-1.36-.61-1.36-1.36s.61-1.36 1.36-1.36 1.36.61 1.36 1.36-.61 1.36-1.36 1.36zM385.41 97.76c-1.91-.64-5.73-1.91-7.64-2.82-3.82-1.91-5.27-3.18-6.73-4.27-.55-.45-1.18-.64-1.91-.64s-1.36.18-1.91.55c-1.45 1.09-2.91 2.36-6.73 4.27-1.91.91-5.73 2.18-7.64 2.82-1.27.45-2 1.55-1.91 2.82.36 4.18 1.36 12.27 3.82 17.27 2.91 5.73 10.09 10.18 12.91 11.91.45.27.91.36 1.45.36s1-.09 1.45-.36c2.82-1.73 10-6.18 12.91-11.91 2.45-5 3.45-13.09 3.82-17.09.09-1.36-.73-2.55-1.91-2.91zm-3.55 19.18c-1.82 3.64-5.91 7.36-12.18 11.18-.18 0-.36.09-.55.09s-.36-.09-.45-.18c-6.36-3.73-10.45-7.55-12.27-11.09-2.55-5.09-3.45-13.91-3.64-16.45-.09-.64.55-.91.73-1l.73-.27c2.09-.73 5.36-1.82 7.18-2.73 3.45-1.73 5.09-3 6.45-4 .18-.18.36-.27.55-.45 0-.09.27-.18.64-.18h.18c.36 0 .64.09.73.18.18.18.36.27.55.45 1.27 1 2.91 2.27 6.45 4 1.82.91 5 2 7.18 2.73l.73.27c.18.09.73.27.73 1-.27 2.55-1.18 11.36-3.73 16.45zm-6.27-1.18l-.91-.91-.64.64.91.91c-3.27 2.91-8.27 2.91-11.55 0l.91-.91-.64-.64-.91.91c-2.91-3.27-2.91-8.27 0-11.55l.91.91.64-.64-.91-.91c3.27-2.91 8.27-2.91 11.55 0l-1.64 1.64c-2.45-2.18-6.18-2-8.55.27-2.45 2.45-2.45 6.45 0 8.91 1.27 1.27 2.82 1.82 4.45 1.82s3.18-.64 4.45-1.82c1.18-1.18 1.82-2.64 1.82-4.45h-.91c0 1.82-.55 2.82-1.55 3.82-2.09 2.09-5.55 2.09-7.64 0s-2.09-5.55 0-7.64c2-2 5.18-2.09 7.27-.27l-1.45 1.45c-1.36-1.09-3.36-1-4.55.27a3.464 3.464 0 000 4.91c.64.64 1.55 1 2.45 1s1.82-.36 2.45-1 1-1.55 1-2.45h-.91c0 .91-.27 1.36-.73 1.82-1 1-2.64 1-3.64 0s-1-2.64 0-3.64c.91-.91 2.27-1 3.27-.27l-.91.91c-.18-.09-.36-.09-.55-.09-.73 0-1.36.64-1.36 1.36s.64 1.36 1.36 1.36 1.36-.64 1.36-1.36c0-.18-.09-.36-.09-.55l7.36-7.36-.64-.64-1.55 1.55a9.603 9.603 0 00-12.82 0l-1.55-1.55-.64.64 1.55 1.55a9.603 9.603 0 000 12.82l-1.55 1.55.64.64 1.55-1.55c1.82 1.64 4.09 2.45 6.45 2.45s4.64-.82 6.45-2.45l1.55 1.55.64-.64-1.55-1.55c1.64-1.73 2.45-3.73 2.45-6.45h-.91c-.09 1.73-.91 4.09-2.27 5.64z'
      />
      <path className='choose3_svg__cls-1' d='M160.46 111.07v69' />
      <circle className='choose3_svg__cls-10' cx={160.46} cy={183.07} r={3.5} />
      <path className='choose3_svg__cls-1' d='M536.46 111.07v69' />
      <circle className='choose3_svg__cls-10' cx={536.46} cy={183.07} r={3.5} />
      <path
        className='choose3_svg__cls-10'
        d='M348.82 2.01c11.09.96 19.95 9.82 20.91 20.91h2.01C370.77 10.73 361.02.98 348.83.01v2.01zM323.91 22.91c.96-11.09 9.82-19.95 20.91-20.91V0c-12.19.97-21.94 10.72-22.91 22.91h2.01zM344.82 47.82c-11.09-.96-19.95-9.82-20.91-20.91h-2.01c.97 12.19 10.72 21.94 22.91 22.91v-2.01zM369.72 26.91c-.96 11.09-9.82 19.95-20.91 20.91v2.01c12.19-.97 21.94-10.72 22.91-22.91h-2.01z'
      />
    </g>
  </svg>
)
export default SvgChoose3
